__turbopack_context__.v({
  "container": "Monthly10kGiveaway-module__l86swW__container",
  "drawDateBadge": "Monthly10kGiveaway-module__l86swW__drawDateBadge",
  "introText": "Monthly10kGiveaway-module__l86swW__introText",
  "monthlyLink": "Monthly10kGiveaway-module__l86swW__monthlyLink",
  "prizeImageContainer": "Monthly10kGiveaway-module__l86swW__prizeImageContainer",
  "prizeInfo": "Monthly10kGiveaway-module__l86swW__prizeInfo",
  "prizeTextContainer": "Monthly10kGiveaway-module__l86swW__prizeTextContainer",
  "prizeTitle": "Monthly10kGiveaway-module__l86swW__prizeTitle",
  "progressionSkeletonCircle": "Monthly10kGiveaway-module__l86swW__progressionSkeletonCircle",
  "progressionSkeletons": "Monthly10kGiveaway-module__l86swW__progressionSkeletons",
});
